/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import 'bootstrap/js/dist/util';
import axios from 'axios';

/*------------------------------------*\
    SEARCH AUTOCOMPLETE
\*------------------------------------*/
class AutoComplete {
    constructor(passedElement) {
        let self = this;
        self.elem = passedElement;
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;

        const axios = require('axios');
        let input = document.querySelector('.autocomplete');
        var endpoint = document.getElementById("endpoint").value;

        input.oninput = handleInput;

        function handleInput(e) {
            axios.get(endpoint + '/api/horse/search?name=' + e.target.value, {
                headers: {
                    'key': 'zGNhtVA23EkmSqbLFM7Z5pV5Z3FEwX',
                    'secret': '9FU]^b(e-tafe{C)>9U%&m7%9pZ~+}=5hVSU;{_D',
                }
            }).then(response => {
                var names = response.data.data.map(function(i) {
                    return i.name;
                });
                autocomplete(document.getElementById("hq"), names);
            });
        }

        function autocomplete(inp, arr) {
            var currentFocus;
            inp.addEventListener("input", function(e) {
                var a, b, i, val = this.value;
                closeAllLists();
                if (!val) { return false; }
                currentFocus = -1;
                a = document.createElement("div");
                a.setAttribute("id", this.id + "autocomplete-list");
                a.setAttribute("class", "autocomplete-items");
                this.parentNode.appendChild(a);
                for (i = 0; i < arr.length; i++) {
                  if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
                    b = document.createElement("div");
                    b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
                    b.innerHTML += arr[i].substr(val.length);
                    b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                    b.addEventListener("click", function(e) {
                        inp.value = this.getElementsByTagName("input")[0].value;
                        closeAllLists();
                    });
                    a.appendChild(b);
                  }
                }
            });
            function closeAllLists(elmnt) {
                var x = document.getElementsByClassName("autocomplete-items");
                for (var i = 0; i < x.length; i++) {
                    if (elmnt != x[i] && elmnt != inp) {
                        x[i].parentNode.removeChild(x[i]);
                    }
                }
            }
            document.addEventListener("click", function (e) {
                closeAllLists(e.target);
            });
        }          
    };
}

export default AutoComplete;
